import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function marketNotOpenTodayBuilder() {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        The market is closed today, cannot enter trade plan.{' '}
      </Body3>
    </td>
  );
}
